import { Component, OnInit, Input, EventEmitter, OnDestroy } from '@angular/core';
import { AlertController, LoadingController, Platform } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { WorkpermitService } from '../service/workpermit.service';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormGroup, FormControl, Validators, ValidatorFn, FormBuilder, Form, AbstractControl } from '@angular/forms';
import { ActionType, SignatureType, SignatureTypeConstant } from '../shared/enum/shared.enum';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { AddSignatureModal } from './add-signature-modal/add-signature-modal.component';
import { finalize } from 'rxjs/operators';
import { chain } from 'lodash';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-workpermit',
  templateUrl: './workpermit.page.html',
  styleUrls: ['./workpermit.page.scss', './workpermit.page.responsive.scss'],
})
export class WorkpermitPage implements OnInit, OnDestroy {
  isToggleMenu = false;
  isInvalidJobSpecificHazardRisk = [];
  ACTION_TYPE = ActionType.submit
  fromDateActivityArray = [];
  checkList = [];
  checkListQuestionAnswer = [];
  signUserType = 'Contractor';
  wpNo: number = null;
  signitureSubscription: Subscription;
  signatureUploadSubscription: Subscription;
  workDetailsData: any = {};
  jobSafetyAnalysisDescription = ['Height Work', 'Electrical Work', 'Confined space entry', 'Excavation Work']
  selectedSignitureType: string = '';
  SignatureType = SignatureType;
  workpaperId: number = null;
  segment: number = 1;
  customSegment: number = 1;
  dataSubmitted: boolean = false;
  modal: HTMLElement;
  dataResult: any = {};
  checkListQuestation: any = {};
  dataResult1: any = [];
  index: any;
  signInput: boolean = false;
  signLabel: boolean = true;
  disableSegment1: boolean = false;
  disableSegment2: boolean = false;
  disableSegment3: boolean = false;
  disableSegment4: boolean = false;
  imagePreview: any = {};
  inputFile: boolean = false;
  hideDetails: boolean = true;
  allActivityData: any = [];
  notFocusedResponsibleSAVW_ContactNo = true;
  alphabet = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

  typeArray = [];
  TYPEOFWORK = [
    { id: 1, name: 'Height', status: false },
    { id: 2, name: 'Electrical', status: false },
    { id: 3, name: 'Confined Space', status: false },
    { id: 4, name: 'Excavation', status: false }
  ];
  showSignFirst: number = 0;

  workPermit: FormGroup;
  loadingRef: HTMLIonLoadingElement;

  constructor(
    public alertController: AlertController, public route: ActivatedRoute,
    public modalController: ModalController,
    public wpservice: WorkpermitService,
    public fb: FormBuilder,
    public loadingController: LoadingController,
    public datePipe: DatePipe,
    public platform: Platform
  ) {

    this.platform.ready().then(() => {
      this.hideLoaderIfExist();
    })

    forkJoin(
      this.platform.pause,
      this.platform.resume,
      this.platform.resize,
      this.platform.ready,
    ).subscribe(() => {
      this.hideLoaderIfExist();
    })
  }

  ngOnDestroy(): void {
    this.hideLoaderIfExist();
  }

  async hideLoaderIfExist() {
    if (this.loadingRef) {
      this.loadingRef?.dismiss();
    }
    const data = await this.loadingController?.getTop();
    if (data) {
      data?.dismiss();
    }
  }


  isEmpty(obj) { return Object.keys(obj).length === 0; }

  addCheckboxesForWorkType() {
    const checkArray: FormArray = this.typeOfWorkControls;
    this.TYPEOFWORK.forEach((data) => data.status ? checkArray.push(new FormControl(true)) : checkArray.push(new FormControl(false)));
  };

  get typeOfWorkControls(): FormArray {
    return this.workDetailsForm.get("typeOfWork") as FormArray
  }

  get selecetedValueTypeOfWork() {
    const selectedValues = this.typeOfWorkControls.value
      .map((checked, i) => checked ? this.TYPEOFWORK[i].name : null)
      .filter(Boolean);
    return selectedValues.join(',')
  }


  ngOnInit() {
    this.dataSubmitted = false;
    this.workPermit = this.prepareForm();
    this.hideLoaderIfExist();
    this.disableSegment1 = true;
    this.workpaperId = this.route?.snapshot?.queryParams?.id;
    this.getAllDataWorkPermitById(this.workpaperId);
    this.getAllDailyActivityById(this.workpaperId);
    console.log('id', this.workpaperId);

    this.workPermit.valueChanges.subscribe((data) => {
      const isInvalidJobSpecificHazardRiskArray = this.getIsInvalidJobSpecificHazardRiskArray(this.jobSpecificRiskAssesmentFormArray?.value)
      if (this.dataSubmitted && isInvalidJobSpecificHazardRiskArray.findIndex(({ isInvalidJobSpecificHazardRisk = false }) => isInvalidJobSpecificHazardRisk) === -1) {
       this.isInvalidJobSpecificHazardRisk = this.getIsInvalidJobSpecificHazardRiskArray(data?.jobSpecificRiskAssesment);
      }
    })
  }

  prepareJobSafetyAnalysisRequestFormGroupAndPatchValue(data) {
    const formGroup = this.wpservice.getJobSafetyAnalysisRequestFormGroup();
    formGroup.patchValue({ ...data });
    return formGroup;
  }

  getPreparedFormArrayForKJobSafetyAnalysisRequests(wpNo) {
    return new FormArray(this.jobSafetyAnalysisDescription.map((description) => {
      return this.prepareJobSafetyAnalysisRequestFormGroupAndPatchValue({ description, wpNo })
    }))
  }

  getJobSpecificHazardRiskAndPatch(list = []): FormGroup[] {
    return new Array(5).fill({}).map((data, index) => {
      const formGroupHazardRisk = this.wpservice.getJobSpecificHazardRiskForm()
      if (list[index]) {
        formGroupHazardRisk.patchValue(list[index])
      }
      return formGroupHazardRisk
    })
  }

  get jobSpecificRiskAssesmentBlankForm() {
    const formGroupControl = this.wpservice.getJobSpecificRiskAssessmentPayloadFormGroup()
    const jobSpecificHazardRisk = formGroupControl.get('jobSpecificHazardRisk') as FormArray;
    this.getJobSpecificHazardRiskAndPatch().forEach((control) => {
      jobSpecificHazardRisk.push(control)
    })
    return formGroupControl;
  }

  getSrNoByIndex(index) {
    return index + 1
  }

  getPreparedFormArrayForListOfContractorWorkPermitSignatures(): FormGroup[] {
    return Array(30).fill({}).map((data, index) => {
      const srNo = this.getSrNoByIndex(index);
      return this.wpservice.getWorkPermitContractorSignsRequestsFormGroup(srNo);
    })
  }

  getPreparedFormArrayForListOfContractorWorkPermitSignaturesByLength(length, startIndex): FormGroup[] {
    return Array(length).fill({}).map((data, index) => {
      const srNo = this.getSrNoByIndex(index + startIndex);
      return this.wpservice.getWorkPermitContractorSignsRequestsFormGroup(srNo);
    })
  }

  getCheckListQuestionAnswer() {
    let parsedData = [];
    Object.keys(this.checkListQuestation).forEach((key) => {
      console.log(key)
      parsedData = [...parsedData, ...this.checkListQuestation[key]]
    });

    console.log('parsedData', parsedData)

    return chain(parsedData)?.map(({ active, answer, checklists, remark, id: checkListQuestionId, questionId: id }) => {
      const details = {
        active: true,
        answer,
        remark: remark || '',
        checkList: checklists?.id || null,
        checkListQuestion: checkListQuestionId || null,
        workPermit: this.WpNo,
        id: id || null
      }

      if (details?.id === null) {
        delete details.id;
      }

      return details;
    })?.value() || [];
  }

  prepareForm() {
    return this.fb.group({
      //work details form group()
      jobSafetyApproval: this.wpservice.getJobSafetyApprovalSignatureFormGroup(),
      vWResponsibleExecution: this.wpservice.getSignatureFormGroupNotRequired(),
      areaInChargeSAVWApproval: this.wpservice.getSignatureFormGroupNotRequired(),
      sAVWIPLResponsibleExecutionApproval: this.wpservice.getSignatureFormGroupNotRequired(),
      areaInChargeSAVWClosure: this.wpservice.getSignatureFormGroupNotRequired(),
      sAVWIPLResponsibleExecutionClosure: this.wpservice.getSignatureFormGroupNotRequired(),

     // checkListApprovalRequest: this.wpservice.getSignatureFormGroup(), // third tab signatutre
      checkListQuestionsAnswers: [],
      jobSpecificRiskAssesment: this.fb.array([]),
      // inchargeSignatureApprovalRequest: this.wpservice.getInchargeSignatureFormGroup(), // last tab
      jobSafetyAnalysisRequests: this.fb.array([]),
      // jobSpecificRiskAssessment: this.wpservice.getjobSpecificRiskAssessmentFormGroup(),
      // safetyOfficerApprovalRequest: this.wpservice.getSafetyOfficerSignatureFormGroup(), //  last tab signature
      workDetails: this.wpservice.getWorkDetailFormGroup(),
      workPermitApprovalSignature: this.wpservice.getSignatureFormGroup(), // first signature
      workPermitClosureSignature: this.wpservice.getWorkPermitClosureSignatureFormGroup(), // second signature
      workPermitContractorSignsRequests: this.fb.array([]),
      // jobSpecificRiskAssessmentPayload: this.wpservice.getJobSpecificRiskAssessmentPayloadFormGroup(),
      wpNo: [null]
    })
  }

  get jobSafetyAnalysisRequestsForm() {
    return this.workPermit?.get('jobSafetyAnalysisRequests') as FormArray;
  }

  get workPermitContractorSignsRequestsForm() {
    return this.workPermit?.get('workPermitContractorSignsRequests') as FormArray;
  }

  get jobSpecificHazardRiskFormArray() {
    return this.jobSpecificRiskAssessmentPayloadFormGroup?.get('jobSpecificHazardRisk') as FormArray;
  }

  getJobSpecificHazardRiskFormArrayByIndex(index) {
    return this.jobSpecificRiskAssesmentFormArray?.at(index)?.get('jobSpecificHazardRisk') as FormArray;
  }

  get jobSpecificRiskAssesmentFormArray() {
    return this.workPermit?.get('jobSpecificRiskAssesment') as FormArray;
  }


  get jobSpecificRiskAssessmentPayloadFormGroup() {
    return this.workPermit?.get('jobSpecificRiskAssessmentPayload');
  }

  getJobSpecificRiskAssesmentByIndex(index) {
    return this.jobSpecificRiskAssesmentFormArray?.at(index)
  }

  getJobSpecificRiskAssesmentFileUploadDetailsByIndex(index) {
    return {
      uploadFile: this.jobSpecificRiskAssesmentFormArray?.at(index)?.get('uploadFile')?.value,
      uploadFileName: this.jobSpecificRiskAssesmentFormArray?.at(index)?.get('uploadedFileName')?.value
    }
  }

  getSAVWExeInChargeSignatureByIndex(index): any {
    return this.jobSpecificRiskAssesmentFormArray?.at(index)?.get('jobSpecificRiskApproval').value?.find((data: any) => data?.signUserType === SignatureTypeConstant.SAVWExeInCharge);
  }

  getSAVWAreaInChargeSignatureByIndex(index): any {
    return this.jobSpecificRiskAssesmentFormArray?.at(index)?.get('jobSpecificRiskApproval').value?.find((data: any) => data?.signUserType === SignatureTypeConstant.SAVWAreaInCharge);
  }

  getSAVWSafetySignatureByIndex(index): any {
    return this.jobSpecificRiskAssesmentFormArray?.at(index)?.get('jobSpecificRiskApproval').value?.find((data: any) => data?.signUserType === SignatureTypeConstant.SAVWSafety);
  }


  getSafetyOfficerApprovalRequestSignatureByIndex(index): AbstractControl {
    return this.jobSpecificRiskAssesmentFormArray?.at(index)?.get('safetyOfficerSignature');
  }

  getInchargeSignatureApprovalRequestSignatureByIndex(index): AbstractControl {
    return this.jobSpecificRiskAssesmentFormArray?.at(index)?.get('inChargeSignature');
  }

  isInvalidInchargeSignatureApprovalRequestSignature(jobSpecificRiskIndex) {
    return this.dataSubmitted && this.getInchargeSignatureApprovalRequestSignatureByIndex(jobSpecificRiskIndex)?.touched && this.getInchargeSignatureApprovalRequestSignatureByIndex(jobSpecificRiskIndex)?.invalid;
  }

  isInvalidSafetyOfficerApprovalRequestSignature(jobSpecificRiskIndex) {
    return this.dataSubmitted && this.getSafetyOfficerApprovalRequestSignatureByIndex(jobSpecificRiskIndex)?.touched && this.getSafetyOfficerApprovalRequestSignatureByIndex(jobSpecificRiskIndex)?.invalid;
  }


  // get safetyOfficerApprovalRequestSignatureFormGroup() {
  //   return this.workPermit.get('safetyOfficerApprovalRequest');
  // }

  // get inchargeSignatureApprovalRequestSignatureFormGroup() {
  //   return this.workPermit.get('inchargeSignatureApprovalRequest');
  // }

  get sAVWIPLResponsibleExecutionApprovalForm () {
    return this.workPermit.get('sAVWIPLResponsibleExecutionApproval');
  }

  get sAVWIPLResponsibleExecutionClosureForm() {
    return this.workPermit.get('sAVWIPLResponsibleExecutionClosure');
  }

  get areaInChargeSAVWApprovalForm() {
    return this.workPermit.get('areaInChargeSAVWApproval');
  }

  get vWResponsibleExecutionForm() {
    return this.workPermit.get('vWResponsibleExecution');
  }

  get JobSafetyApprovalSignatureForm() {
    return this.workPermit.get('jobSafetyApproval');
  }

  get areaInChargeSAVWClosureForm() {
    return this.workPermit.get('areaInChargeSAVWClosure');
  }

  get workPermitApprovalSignatureForm() {
    return this.workPermit.get('workPermitApprovalSignature');
  }

  get checkListApprovalRequestSignatureForm() {
    return this.workPermit.get('checkListApprovalRequest');
  }



  get workPermitClosureSignatureForm() {
    return this.workPermit.get('workPermitClosureSignature');
  }

  get UserId() {
    return this.workDetailsForm.get('responsibleSAVW_Person')?.value?.id
  }

  get WpNo() {
    return this.workDetailsForm.get('wpNo').value
  }
patchValueOfFormInchargeSign(jobSpecificRiskAssesmentForm){
  jobSpecificRiskAssesmentForm.patchValue({
    inChargeSignature:this.workPermitApprovalSignatureForm.value.signature,
    inChargefileName:this.workPermitApprovalSignatureForm.value.fileName
  })
}
  onAddJobRiskAssessment() {
    const jobSpecificRiskAssesmentForm=this.jobSpecificRiskAssesmentBlankForm;
    this.patchValueOfFormInchargeSign(jobSpecificRiskAssesmentForm);
    this.jobSpecificRiskAssesmentFormArray.push(jobSpecificRiskAssesmentForm)
  }

  onRemoveJobRiskAssessment(index: number) {
    this.jobSpecificRiskAssesmentFormArray.removeAt(index);
  }

  onUploadFile($event, index) {
    const file = $event.target.files[0];
    if (!file || file.length == 0) {
      alert('You must select an file');
      return;
    }
    const fileName = file.name;
    const fileType = file.type;
    // var mimeType = $event.target.files[0].type;
    // if (mimeType.match(/image\/*/) == null) {
    //   alert('Upload only PNG, JPG, JEPG signature images');
    // 	return;
    // }
    const url = `api/contractor/upload-file?fileName=${fileName}&fileType=${fileType}`;
    const formData = new FormData();
    formData.append('file', file);
    this.presentLoading('uploading');
    this.wpservice.workPermitApproval(url, formData)
      .pipe(finalize(() => this.loadingRef?.dismiss()))
      .subscribe(({ data }: any) => {
        this.getJobSpecificRiskAssesmentByIndex(index).patchValue({
          uploadFile: data || '',
          uploadedFileName: fileName || ''
        });
        this.uploadSuccessMessage('File uploaded successfully')
      });
    console.log(file);
  }

  onUploadImage($event, index) {
    const file = $event.target.files[0];
    if (!file || file.length == 0) {
      alert('You must select an file');
      return;
    }
    const fileName = file.name;
    const fileType = file.type;
    var mimeType = $event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      alert('Upload only PNG, JPG, JEPG signature images');
      return;
    }
    const url = `api/contractor/upload-file?fileName=${fileName}&fileType=${fileType}`;
    const formData = new FormData();
    formData.append('file', file);
    this.presentLoading('uploading');
    this.wpservice.workPermitApproval(url, formData)
      .pipe(finalize(() => this.loadingRef?.dismiss()))
      .subscribe(({ data }: any) => {
        this.getJobSpecificRiskAssesmentByIndex(index).patchValue({
          uploadImage: data || '',
          uploadedImageFileName: fileName || ''
        });
        this.uploadSuccessMessage('Image uploaded successfully')
      });
    console.log(file);
  }

  uploadWorkPermitApprovalSignature({ formData, fileName, fileType, name }) {
    this.presentLoading('uploading');
    this.wpservice.workPermitApproval(`api/contractor/WorkPermitApproval?fileName=${fileName}&fileType=${fileType}&user=${this.UserId}&wpNo=${this.WpNo}&signUserType=${this.signUserType}&name=${name}`, formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe(({ data = null }: any) => {
        if (data) {
          this.workPermitApprovalSignatureForm.patchValue(data)
          this.getJobSpecificRiskAssesmentByIndex(0).patchValue({
            inChargeSignature: data.signature,
            inChargefileName: data.fileName
          })
          this.uploadSuccessMessage();
        }
      },
        (error) => console.log("Something went wrong", error));
  }

  uploadWorkPermitClosureSignature({ formData, fileName, fileType, name }) {
    this.presentLoading('uploading');
    this.wpservice.workPermitApproval(`api/contractor/WorkPermitClosure?fileName=${fileName}&fileType=${fileType}&user=${this.UserId}&wpNo=${this.WpNo}&signUserType=${this.signUserType}&name=${name}`, formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe(({ data = null }: any) => {
        if (data) {
          this.workPermitClosureSignatureForm.patchValue(data)
          this.uploadSuccessMessage();
        }
      },
        (error) => console.log("Something went wrong", error));
  }

  uploadJobSafetyContractorSignature({ formData, fileName, fileType, name = "N/A" }, srNo) {
    const formGroupSignature = this.workPermitContractorSignsRequestsForm.controls[srNo - 1];
    name = formGroupSignature?.get('name')?.value;
    this.presentLoading();
    this.wpservice.workPermitApproval(`api/contractor/addContractorWorkPermit?fileName=${fileName}&fileType=${fileType}&user=${this.UserId}&wpNo=${this.WpNo}&signUserType=${this.signUserType}&name=${name}`, formData)
      .pipe(finalize(() => {
        this.modalController?.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe(({ data = null }: any) => {
        if (data) {
          formGroupSignature.patchValue({ ...data, name: formGroupSignature.get('name').value });
          this.uploadSuccessMessage();
        }
      },
        (error) => console.log("Something went wrong", error));
  }

  uploadChekListApprovalRequestSignature({ formData, fileName, fileType, name }) {
    if (this.signatureUploadSubscription) {
      this.signatureUploadSubscription?.unsubscribe()
    }
    this.presentLoading('uploading');
    this.signatureUploadSubscription = this.wpservice.workPermitApproval(`api/contractor/checkListApproval?fileName=${fileName}&fileType=${fileType}&user=${this.UserId}&workPermit=${this.WpNo}&signUserType=${this.signUserType}&name=${name}`, formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe(({ data = null }: any) => {
        if (data) {
          this.checkListApprovalRequestSignatureForm.patchValue(data)
          this.uploadSuccessMessage();
        }
      },
        (error) => console.log("Something went wrong", error));
  }
  /// last tab
  uploadSafetyOfficerApprovalRequestSignature({ formData, fileName, fileType, name }, index) {
    this.presentLoading('uploading');
    this.wpservice.workPermitApproval(`api/contractor/upload-file?fileName=${fileName}&fileType=${fileType}`, formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe(({ data = null }: any) => {
        if (data) {
          this.getJobSpecificRiskAssesmentByIndex(index)?.patchValue({
            safetyOfficerSignature: data,
            safetyOfficerfileName: fileName
          });
          this.uploadSuccessMessage();
        }
      },
        (error) => console.log("Something went wrong", error));
  }
  /// last tab
  uploadInchargeSignatureApprovalRequestSignature({ formData, fileName, fileType, name }, index) {
    this.presentLoading('uploading');
    this.wpservice.workPermitApproval(`api/contractor/upload-file?fileName=${fileName}&fileType=${fileType}`, formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe(({ data = null }: any) => {
        if (data) {
          this.getJobSpecificRiskAssesmentByIndex(index).patchValue({
            inChargeSignature: data,
            inChargefileName: fileName
          })

          this.uploadSuccessMessage();
        }
      },
        (error) => console.log("Something went wrong", error));
  }




  async uploadSuccessMessage(message = 'Your signature has been uploaded successfully.') {
    const alert = await this.alertController.create({
      animated: true,
      cssClass: 'saveAsDraftAlert Succuss2',
      header: '',
      message,
      buttons: [{ text: 'OK', role: 'cancel', cssClass: 'ok' }]
    });
    await alert.present();
  }


  async showUploadSignature($event, type, srNo = null, index = 0) {
    if (this.signitureSubscription) {
      this.signitureSubscription.unsubscribe();
    }
    const eventEmitterSubject = new EventEmitter();
    this.signitureSubscription = eventEmitterSubject.subscribe(res => {
      // approval 
      if (type === SignatureType.workPermitApprovalSignature) {
        this.uploadWorkPermitApprovalSignature(res)
      }
      // closure 
      if (type === SignatureType.workPermitClosureSignature) {
        this.uploadWorkPermitClosureSignature(res);
        // this.workPermit.get('workPermitClosureSignature').patchValue(data);
      }

      if (type === SignatureType.checkListApprovalRequest) {
        this.uploadChekListApprovalRequestSignature(res);
      }

      if (type === SignatureType.jobSafetySignatureRequest) {
        this.uploadJobSafetyContractorSignature(res, srNo);
      }

      if (type === SignatureType.safetyOfficerApprovalRequest) {
        this.uploadSafetyOfficerApprovalRequestSignature(res, index);
      }

      if (type === SignatureType.inchargeSignatureApprovalRequest) {
        this.uploadInchargeSignatureApprovalRequestSignature(res, index);
      }
    });

    const isNameRequired = type === SignatureType.workPermitApprovalSignature || type === SignatureType.workPermitClosureSignature
      || type === SignatureType.checkListApprovalRequest;

    const modal = await this.modalController.create({
      component: AddSignatureModal,
      componentProps: {
        isShowContractorInput: isNameRequired ? true : false,
        onUpload: eventEmitterSubject
      },
      cssClass: 'addSign',
      animated: true,
    });

    return await modal.present();
  }

  showSignBtn($event, index) {
    this.showSignFirst = index;
    // this.addItemsData[this.showSignFirst].isShow = true;
  }

  refreshData(allDataResponse) {
    if (allDataResponse) {
      this.typeOfWorkControls.clear();
      this.jobSafetyAnalysisRequestsForm?.clear();
      this.workPermitContractorSignsRequestsForm?.clear();
      // this.jobSpecificHazardRiskFormArray?.clear();
      this.jobSpecificRiskAssesmentFormArray?.clear();
      this.typeArray = [];
      let listOfJobSafetyAnalysis: any;
      let listOfContractorWorkPermitSignatures: any;
      // let jobSpecificHazardRisk: any;

      this.typeArray = allDataResponse?.workPermit?.typeOfWork?.split(',');
      this.TYPEOFWORK.forEach((data2) => {
        if (this.typeArray.find((typeOfWork) => typeOfWork.toLowerCase() === data2.name.toLowerCase())) {
          data2.status = true;
        } else {
          data2.status = false;
        }
      });

      const preparedWPDetails = {
        ...allDataResponse.workPermit,
        area: this.workDetailsData?.area,
        typeOfWork: [],
        responsibleSAVW_ContactNo: this.workDetailsData?.responsibleSAVWPerson.contactNo,
        responsibleSAVW_Person: this.workDetailsData?.responsibleSAVWPerson
      }

      // console.log('wpDetails', wpDetails);


      if (!allDataResponse?.listOfJobSafetyAnalysis || allDataResponse?.listOfJobSafetyAnalysis?.length === 0) {
        listOfJobSafetyAnalysis = this.getPreparedFormArrayForKJobSafetyAnalysisRequests(preparedWPDetails.wpNo)?.controls;
      } else {
        listOfJobSafetyAnalysis = allDataResponse?.listOfJobSafetyAnalysis.map((data) => {
          return this.prepareJobSafetyAnalysisRequestFormGroupAndPatchValue(data)
        })
      }

      if (!allDataResponse?.listOfContractorWorkPermitSignatures || allDataResponse?.listOfContractorWorkPermitSignatures?.length === 0) {
        listOfContractorWorkPermitSignatures = this.getPreparedFormArrayForListOfContractorWorkPermitSignatures();
      } else {
        listOfContractorWorkPermitSignatures = allDataResponse?.listOfContractorWorkPermitSignatures.map((data, index) => {
          const srNo = this.getSrNoByIndex(index);
          const formGroupContr = this.wpservice.getWorkPermitContractorSignsRequestsFormGroup(srNo);
          formGroupContr.patchValue(data);
          return formGroupContr;
        })

        if (listOfContractorWorkPermitSignatures.length !== 30) {
          const emptyArrayReqCount = 30 - listOfContractorWorkPermitSignatures.length;
          const formArrayContractSignature = this.getPreparedFormArrayForListOfContractorWorkPermitSignaturesByLength(emptyArrayReqCount, listOfContractorWorkPermitSignatures.length);
          listOfContractorWorkPermitSignatures = [...listOfContractorWorkPermitSignatures, ...formArrayContractSignature]
        }
      }

      // if (!allDataResponse?.jobSpecificRiskAssesment?.jobSpecificHazardRisk || allDataResponse?.jobSpecificRiskAssesment?.jobSpecificHazardRisk?.length === 0) {
      //   jobSpecificHazardRisk = this.getJobSpecificHazardRiskAndPatch();
      // } else {
      //   jobSpecificHazardRisk = this.getJobSpecificHazardRiskAndPatch(allDataResponse?.jobSpecificRiskAssesment.jobSpecificHazardRisk);
      // }

      if (!allDataResponse?.jobSpecificRiskAssesment || allDataResponse?.jobSpecificRiskAssesment.length === 0) {
        // this.jobSpecificRiskAssesmentFormArray.at(0).
        const jobSpecificRiskAssesmentForm=this.jobSpecificRiskAssesmentBlankForm;
        this.patchValueOfFormInchargeSign(jobSpecificRiskAssesmentForm);
        this.jobSpecificRiskAssesmentFormArray.push(jobSpecificRiskAssesmentForm);
      } else {
        allDataResponse?.jobSpecificRiskAssesment?.forEach((jobSpecificRiskAssesmentData) => {
          const formControlMain = this.jobSpecificRiskAssesmentBlankForm
          formControlMain.patchValue({ ...jobSpecificRiskAssesmentData, uploadedFileName: jobSpecificRiskAssesmentData?.uploadFileName, uploadedImageFileName: jobSpecificRiskAssesmentData?.imageFileName })
          this.jobSpecificRiskAssesmentFormArray.push(formControlMain);
        })
      }

      listOfJobSafetyAnalysis.forEach(control => {
        this.jobSafetyAnalysisRequestsForm.push(control)
      });

      listOfContractorWorkPermitSignatures.forEach(control => {
        this.workPermitContractorSignsRequestsForm.push(control)
      });

      // jobSpecificHazardRisk.forEach(control => {
      //   this.jobSpecificHazardRiskFormArray.push(control)
      // });

      this.workPermit.patchValue({
        ...allDataResponse,
        workDetails: preparedWPDetails,
        sAVWIPLResponsibleExecutionClosure: allDataResponse.workPermitClosure?.find(({ signUserType }) => signUserType === SignatureTypeConstant.SAVWIPLResponsibleExecutionClosure) || {},
        areaInChargeSAVWClosure: allDataResponse.workPermitClosure?.find(({ signUserType }) => signUserType === SignatureTypeConstant.AreaInChargeSAVWClosure) || {},
        sAVWIPLResponsibleExecutionApproval: allDataResponse.workPermitApprovalSignature?.find(({ signUserType }) => signUserType === SignatureTypeConstant.SAVWIPLResponsibleExecutionApproval) || {},
        areaInChargeSAVWApproval: allDataResponse.workPermitApprovalSignature?.find(({ signUserType }) => signUserType === SignatureTypeConstant.AreaInChargeSAVWApproval) || {},
        vWResponsibleExecution: allDataResponse.checkListApproval?.find(({ signUserType }) => signUserType === SignatureTypeConstant.VWResponsibleExecution) || {},
        checkListApprovalRequest: allDataResponse.checkListApproval?.find(({ signUserType }) => signUserType === this.signUserType) || {},
        workPermitClosureSignature: allDataResponse.workPermitClosure?.find(({ signUserType }) => signUserType === this.signUserType) || {},
        workPermitApprovalSignature: allDataResponse.workPermitApprovalSignature?.find(({ signUserType }) => signUserType === this.signUserType) || {},
        wpNo: Number(this.workpaperId)
      });
      this.addCheckboxesForWorkType();

      console.log(this.workPermit)
    }
  }
  remarkBySafetyTeam:any;
  jobSafetySign:any;
  jobSafetySignName:any;
  SAVWExeInChargeJobSpecificSignData:any=[];
  SAVWAreaInChargeJobSpecificSignData:any=[];
  SAVWSafetyJobSpecificSignData:any=[];
  getAllDataWorkPermitById(id) {
    this.presentLoading();
    forkJoin(
      this.wpservice.getAllDataById("api/contractor/getAllDataById", id),
      this.wpservice.getWPDetails("api/contractor/getWorkPermitById", id),
      this.wpservice.getAllCheckList("api/contractor/getAllCheckList")
    ).pipe(finalize(() => {
      this.hideLoaderIfExist();
    })) .subscribe(([allDataResponse, wpDetails, checkList]) => {
        this.checkList = checkList?.data;
        this.updateCheckList(this.checkList, allDataResponse?.data?.listCheckListQuestionAnswers || []);
        if (wpDetails.data) {
          this.workDetailsData = wpDetails.data;
          console.log('workDetailsData', this.workDetailsData)
          this.fromDateActivityArray = this.wpservice.getDatesFromDate(this.workDetailsData.fromDate || new Date());
          console.log(' this.fromDateActivityArray', this.fromDateActivityArray)
        }
        for (let j = 0; j <allDataResponse.data.jobSafetyApproval.length; j++) {
          this.remarkBySafetyTeam=allDataResponse.data.jobSafetyApproval[j].remark;
          this.jobSafetySign=allDataResponse.data.jobSafetyApproval[j].signature;
          this.jobSafetySignName=allDataResponse.data.jobSafetyApproval[j].name;
        }
        for (let i = 0; i <allDataResponse.data.listOfJobSpecificRiskApprovalSignature.length; i++) {
          if(allDataResponse.data.listOfJobSpecificRiskApprovalSignature[i].signUserType=="SAVWIPLResponsibleExecution"){
            this.SAVWExeInChargeJobSpecificSignData.push(allDataResponse.data.listOfJobSpecificRiskApprovalSignature[i]);
          }
          if(allDataResponse.data.listOfJobSpecificRiskApprovalSignature[i].signUserType=="AreaInChargeSAVWIPL"){
            this.SAVWAreaInChargeJobSpecificSignData.push(allDataResponse.data.listOfJobSpecificRiskApprovalSignature[i]);
          }
          if(allDataResponse.data.listOfJobSpecificRiskApprovalSignature[i].signUserType=="SAVWSafety"){
            this.SAVWSafetyJobSpecificSignData.push(allDataResponse.data.listOfJobSpecificRiskApprovalSignature[i]);
          }
        }
        this.refreshData(allDataResponse.data);
      }, () => {
          this.hideLoaderIfExist();
      }, () => {
        this.hideLoaderIfExist();
      });

  }

  updateCheckList(checkList, checklistAnswerUpdated = []) {
    this.dataResult1 = checkList.check || [];
    // console.log( this.dataResult1);
    this.dataResult1.sort(function (x, y) {
      return x.id - y.id;
    });
    this.dataResult1.forEach(object => {
      this.getCheckListQuestionById(object.id, checklistAnswerUpdated);
    });
    console.log('this.dataResult', this.dataResult1);
  }

  getCheckListQuestionById(id, checklistAnswerUpdated) {
    console.log('===checklistDetails', checklistAnswerUpdated);
    this.wpservice.getCheckListQuestionById("api/contractor/getCheckListQuestionById", id)
    .pipe(finalize(() => this.hideLoaderIfExist()))
    .subscribe(resp => {
      this.checkListQuestation[id] = resp?.data?.map((data) => {
        const dbDataAlreadyInserted = checklistAnswerUpdated?.find(({ checkListQuestions: { id } }) => id === data.id)
        return {
          ...data,
          remark: dbDataAlreadyInserted?.id && dbDataAlreadyInserted?.remark ? dbDataAlreadyInserted?.remark : '',
          answer: dbDataAlreadyInserted?.answer ? dbDataAlreadyInserted?.answer : 'NA',
          questionId: dbDataAlreadyInserted?.id ? dbDataAlreadyInserted?.id : null
        }
      });
      console.log('this.dataResult', this.checkListQuestation);
    }, () => {
      this.hideLoaderIfExist();
    }, () => {
      this.hideLoaderIfExist();
    })
  }

  getAllDailyActivityById(workPermitId) {
    this.wpservice.getAllCheckList(`api/contractor/getDailyActivityById/${workPermitId}`).subscribe(({ data  = []}) => {
      this.allActivityData = data;
      console.log('this.allActivityData', this.allActivityData)
    })
  }

  get workDetails() {
    return this.workPermit.controls['workDetails']['controls']
  }

  get workDetailsForm() {
    return this.workPermit.get('workDetails')
  }

  getIsInvalidJobSpecificHazardRiskArray(jobSpecificRiskAssesment = []) {
    let isInvalidJobSpecificHazardRiskList = new Array(jobSpecificRiskAssesment?.length).fill({ isInvalidJobSpecificHazardRisk: false }) || [];
    jobSpecificRiskAssesment?.forEach((data, index) => {
      const isInvalidHazard = data.jobSpecificHazardRisk?.findIndex(({ hazard = '' }) => hazard.trim()) === -1 ? true : false;
      const isInvalidRisk = data.jobSpecificHazardRisk?.findIndex(({ risk = '' }) => risk.trim()) === -1 ? true : false;

      if (isInvalidHazard || isInvalidRisk) {
        isInvalidJobSpecificHazardRiskList[index].isInvalidJobSpecificHazardRisk = true;
      } else {
        isInvalidJobSpecificHazardRiskList[index].isInvalidJobSpecificHazardRisk = false;
      }

      
    });

    return isInvalidJobSpecificHazardRiskList;
  }

  formSubmit() {
    this.dataSubmitted = true; 
  
    this.isInvalidJobSpecificHazardRisk = this.getIsInvalidJobSpecificHazardRiskArray(this.jobSpecificRiskAssesmentFormArray?.value);
    if (this.workPermit.invalid || this.jobSpecificRiskAssesmentFormArray.invalid || this.isInvalidJobSpecificHazardRisk.findIndex(({ isInvalidJobSpecificHazardRisk = false }) => isInvalidJobSpecificHazardRisk) != -1) {
      this.jobSpecificRiskAssesmentFormArray.markAllAsTouched()
      this.jobSpecificRiskAssesmentFormArray.markAsDirty();
      this.errorAlert('Please fill all mandatory details');
      return;
      // alert('Please check all fields in all section fill properly, Error in form!!! ')
    }
    if (this.workPermit.valid) {
      const formDataValues = this.getPreparedFormValueForSave(ActionType.submit);
      this.addOrUpdateWorkPermitContractor('api/contractor/add-or-update-WorkPermit-contractor', formDataValues, ActionType.submit);
    }
    //console.log('Form Submit ---- >')
    // if (this.workPermit.controls.workDetails.dirty && this.customSegment == 1) {
    //   //alert('Please fill mandetory and valid details')
    // }
    // if (this.workPermit.controls.safetyanalysis.invalid && this.customSegment == 2) {
    //   return;
    // }
    // if (this.workPermit.controls.checkList.invalid && this.customSegment == 3) {
    //   return;
    // }
    // if (this.workPermit.controls.riskAssesment.invalid && this.customSegment == 4) {
    //   return;
    // }
  }


  async saveAsDraft() {
    if (this.segment == 1) {
      if (this.workDetailsForm.invalid || this.workPermitApprovalSignatureForm.invalid) {
        this.errorAlert('Please fill all mandatory details');
        return;
      }

      if (this.workDetailsForm.valid && this.workPermitApprovalSignatureForm.valid) {

        const formDataValues = this.getPreparedFormValueForSave(ActionType.save);

        const isUpdateSuccess = await this.addOrUpdateWorkPermitContractor('api/contractor/add-or-update-WorkPermit-contractor', formDataValues);
        if (!isUpdateSuccess) {
          return
        }
        this.disableSegment2 = true;
        // this.setwpNoSafetyAnalysisReques();
      }
    }

    if (this.segment == 2) {
      console.log('this.jobSafetyAnalysisRequestsForm', this.jobSafetyAnalysisRequestsForm)
      if (this.jobSafetyAnalysisRequestsForm.invalid) {
        this.errorAlert('Please fill all mandatory details');
        return;
      }
      else {
        const formDataValues = this.getPreparedFormValueForSave(ActionType.save);
        const isUpdateSuccess = await this.addOrUpdateWorkPermitContractor('api/contractor/add-or-update-WorkPermit-contractor', formDataValues);
        if (!isUpdateSuccess) {
          return
        }
        this.disableSegment3 = true;
      }
    }

    if (this.segment == 3) {
      // if (this.checkListApprovalRequestSignatureForm.invalid) {
      //   this.errorAlert('Please upload signature');
      //   return;
      // }
     // if (this.checkListApprovalRequestSignatureForm.valid) {
        const formDataValues = this.getPreparedFormValueForSave(ActionType.save);
        const isUpdateSuccess = await this.addOrUpdateWorkPermitContractor('api/contractor/add-or-update-WorkPermit-contractor', formDataValues);
        if (!isUpdateSuccess) {
          return
        }
        this.disableSegment4 = true;
     // }

      // if (this.workPermit.controls.checkList.invalid) {
      //   alert('Please fill all mandatory details');
      //   return;
      // } else {
      //   this.disableSegment4 = true;
      // }
    }

    if (this.segment == 4) { 
      const formDataValues = this.getPreparedFormValueForSave(ActionType.save);
      await this.addOrUpdateWorkPermitContractor('api/contractor/add-or-update-WorkPermit-contractor', formDataValues);
      return
    }

    this.segment = ++this.segment;
    this.customSegment = this.segment;

    // const formDataValues = this.getPreparedFormValueForSave(ActionType.save);
    // this.addOrUpdateWorkPermitContractor('api/contractor/add-or-update-WorkPermit-contractor', formDataValues);
  }

  segmentChanged(ev: any) {
    setTimeout(() => {
      this.segment = ev.detail.value;
      this.customSegment = ev.detail.value;

      document.getElementById('ion-segment-' + ev.detail.value)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      });
    })
  
  }

  goToPrevious() {
    this.segment = --this.segment;
    this.customSegment = this.segment;
  }

  getActionSubmit() {
   return this.workDetailsForm?.get('actions')?.value === ActionType.submit ? true : false;
  }


  async addOrUpdateWorkPermitContractor(relativeUrl: string, data: any, type = ActionType.save) {
    this.presentLoading();
    return new Promise((resolve, reject) => {
      this.wpservice.addOrUpdateWorkPermitContractor(relativeUrl, data)
        .pipe(finalize(() => this.loadingRef?.dismiss()))
        .subscribe((resp: any) => {
          this.refreshData(resp?.data);
          this.updateCheckList(this.checkList, resp?.data?.listCheckListQuestionAnswers || []);
          if (type === ActionType.save) {
            this.saveAsDraftSuccessAlert();
          } else {
            this.workDetailsForm.get('actions').patchValue(type)
            // this.formSubmitSuccess();
          }
          
          resolve(true);
          console.log("Work Details - SUCCESS", resp);
        }, err => {
          console.log("Work Details - FAILED", err);
          this.formFailToSubmit();
          resolve(false);
        })
    })

  }

  getPrepareSignatureData({ fileName = '', id = null, signUserType = '', signature = '', user = null, name = null }) {
    let signitureData = null;
    if (id) {
      signitureData = {
        fileName,
        id,
        signUserType,
        signature,
        user: user?.id,
        name: name || 'N/A'
      }
    }
    return signitureData;
  }

  getPreparedWorkDetails(data, type) {
    let details = {
      ...data,
      actions: type,
      area: data?.area?.id,
      areaInCharge: data?.areaInCharge,
      issuedBy: data?.issuedBy,
      isDraft: type === ActionType.save ? true : false,
      responsibleSAVW_ContactNo: data?.responsibleSAVW_ContactNo || null,
      responsibleSAVW_Person: data?.responsibleSAVW_Person?.id || null,
      safetyManagerId: data?.safetyManagerId?.id || null,
      typeOfWork: this.selecetedValueTypeOfWork,
      status: type === ActionType.submit ? 'Resp. Person Review' :  data?.status
    }
    return details;
  }

  getPreparedDataJobSafetyAnalysisRequest(data: [] = []) {
    const filterData = data.filter(({ controlMeasures, hazard, risk }) => controlMeasures && hazard && risk);
    if (filterData.length === 0) {
      return [];
    }
    return data.map((safetyDetails: any) => {
      if (safetyDetails.hasOwnProperty('id') && safetyDetails.id === null) {
        delete safetyDetails.id;
      }
      return {
        ...safetyDetails,
        wpNo: this.WpNo,
        userId: this.workDetailsForm.get('responsibleSAVW_Person')?.value?.id
      }
    })
  }

  workPermitContractorSignsRequests(data: [] = []) {
    const filterData = data.filter(({ signature, name }) => signature && name);
    if (filterData.length === 0) {
      return [];
    }
    return filterData.map((data: any) => {
      delete data.srNo;
      return {
        ...data,
        user: data.user.id
      }
    })
  }

  setwpNoSafetyAnalysisReques() {
    this.jobSafetyAnalysisRequestsForm.controls.forEach((control) => {
      if (!control.value.wpNo) {
        control.patchValue({ wpNo: this.WpNo })
      }
    })
  }

  // getJobSpecificRiskAssessmentPayload(jobSpecificRiskAssessmentPayload) {
  //   if (!jobSpecificRiskAssessmentPayload || !jobSpecificRiskAssessmentPayload?.uploadFile || !jobSpecificRiskAssessmentPayload?.uploadImage) {
  //     return null;
  //   }
  //   return {
  //     ...jobSpecificRiskAssessmentPayload,
  //     user: this.UserId,
  //     wpNo: this.WpNo
  //   }
  // }

  getSafetyOfficerApprovalRequest({ fileName = '', id = null, signUserType = '', safetyOfficerSignature = '', user = null, name = null }) {
    let signitureData = null;
    if (id) {
      signitureData = {
        fileName,
        id,
        signUserType,
        safetyOfficerSignature,
        user: user.id,
        name: name || 'N/A'
      }
    }
    return signitureData;
  }

  getinchargeSignatureApprovalRequestData({ fileName = '', id = null, signUserType = '', inChargeSignature = '', userId = null, name = null }) {
    let signitureData = null;
    if (id) {
      signitureData = {
        fileName,
        id,
        signUserType,
        inChargeSignature,
        user: userId?.id || null,
        name: name || 'N/A'
      }
    }
    return signitureData;
  }

  getPreparedDataJobSpecificHazardRisk(list = []) {
    return list?.map((data) => {
      const payload = {
        ...data,
        id: data?.id || null
      }

      if (payload.id === null) {
        delete payload.id;
      }
      return payload;
    })
  }

  getPreparedDataForJobSpecificRiskAssesment(dataList = []) {
    return dataList?.map((data) => {
      const payload = {
        ...data,
        jobSpecificHazardRisk: this.getPreparedDataJobSpecificHazardRisk(data.jobSpecificHazardRisk),
        id: data?.id || null,
        workPermit: this.WpNo,
        user: this.UserId
      }
      if (payload.id === null) {
        delete payload.id;
      } 
      if (payload.jobSpecificRiskApproval) {
        delete payload.jobSpecificRiskApproval;
      }
      return payload;
    });
  }

  getPreparedFormValueForSave(type) {
    const data = this.workPermit?.value || {};
    return {
      jobSpecificRiskAssessmentPayload: this.getPreparedDataForJobSpecificRiskAssesment(data?.jobSpecificRiskAssesment || []) || [],
   //   checkListApprovalRequest: this.getPrepareSignatureData(data?.checkListApprovalRequest || {}),
      checkListQuestionsAnswers: this.getCheckListQuestionAnswer(),
      workPermitClosureSignature: this.getPrepareSignatureData(data?.workPermitClosureSignature || {}),
      // dailyActivityApprovalSignature: this.getPrepareSignatureData(data?.dailyActivityApprovalSignature || {}),
      // inchargeSignatureApprovalRequest: this.getinchargeSignatureApprovalRequestData(data?.inchargeSignatureApprovalRequest || {}),
      jobSafetyAnalysisRequests: this.getPreparedDataJobSafetyAnalysisRequest(data?.jobSafetyAnalysisRequests) || [],
      // jobSpecificRiskAssessmentPayload: this.getJobSpecificRiskAssessmentPayload(data?.jobSpecificRiskAssessmentPayload),
      // safetyOfficerApprovalRequest: this.getSafetyOfficerApprovalRequest(data?.safetyOfficerApprovalRequest || {}),
      workDetails: this.getPreparedWorkDetails(data.workDetails, type),
      workPermitApprovalSignature: this.getPrepareSignatureData(data?.workPermitApprovalSignature || {}),
      workPermitContractorSignsRequests: this.workPermitContractorSignsRequests(data?.workPermitContractorSignsRequests),
      wpNo: data?.wpNo || this.wpNo
    }
  }

  allowOnlyNumber(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57) && charCode !== 8) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  onFocusField() {
    this.notFocusedResponsibleSAVW_ContactNo = false;
  }

  onFocusOutField() {
    this.notFocusedResponsibleSAVW_ContactNo = true;
  }

  restrictMaxLength(event) {
    console.log('restrictMaxLength', event)
    if (event.target.maxLength && event.target.value.length < event.target.maxLength) {
      return true;
    }
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  async goToNext() {
    if (this.segment == 1) {
      console.log(this.workDetailsForm);
      if (this.workDetailsForm.invalid || this.workPermitApprovalSignatureForm.invalid) {
        this.workDetailsForm.markAsDirty();
        this.workDetailsForm.markAllAsTouched();
        this.errorAlert('Please fill all mandatory details');
        return;
      }

      if (this.workDetailsForm.valid && this.workPermitApprovalSignatureForm.valid) {

        // const formDataValues = this.getPreparedFormValueForSave(ActionType.save);

        // const isUpdateSuccess = await this.addOrUpdateWorkPermitContractor('api/contractor/add-or-update-WorkPermit-contractor', formDataValues);
        // if (!isUpdateSuccess) {
        //   return
        // }
        this.disableSegment2 = true;
        // this.setwpNoSafetyAnalysisReques();
      }
    }

    if (this.segment == 2) {
      console.log('this.jobSafetyAnalysisRequestsForm', this.jobSafetyAnalysisRequestsForm)
      if (this.jobSafetyAnalysisRequestsForm.invalid) {
        this.jobSafetyAnalysisRequestsForm.markAsDirty();
        this.jobSafetyAnalysisRequestsForm.markAllAsTouched();
        this.errorAlert('Please fill all mandatory details');
        return;
      }
      else {
        // const formDataValues = this.getPreparedFormValueForSave(ActionType.save);
        // const isUpdateSuccess = await this.addOrUpdateWorkPermitContractor('api/contractor/add-or-update-WorkPermit-contractor', formDataValues);
        // if (!isUpdateSuccess) {
        //   return
        // }
        this.disableSegment3 = true;
      }
    }

    if (this.segment == 3) {
      // if (this.checkListApprovalRequestSignatureForm.invalid) {
      //   this.errorAlert('Please upload signature');
      //   return;
      // }
     // if (this.checkListApprovalRequestSignatureForm.valid) {
        // const formDataValues = this.getPreparedFormValueForSave(ActionType.save);
        // const isUpdateSuccess = await this.addOrUpdateWorkPermitContractor('api/contractor/add-or-update-WorkPermit-contractor', formDataValues);
        // if (!isUpdateSuccess) {
        //   return
        // }
        this.disableSegment4 = true;
    //  }

      // if (this.workPermit.controls.checkList.invalid) {
      //   alert('Please fill all mandatory details');
      //   return;
      // } else {
      //   this.disableSegment4 = true;
      // }
    }

    this.segment = ++this.segment;
    this.customSegment = this.segment;
  }

  getDailyActivityDataByDate(date) {
   return this.allActivityData?.find((data) => (data?.date && date) && (this.datePipe.transform(date, 'dd/MM/yyyy') === this.datePipe.transform(data?.date, 'dd/MM/yyyy')))?.signature || '';
  }

  submit() {
    //console.log("Final Submit and proceed Method Call ===>");
  }

  presentLoading(msg = 'Please wait...') {
    this.showLoader(msg)
  }

  async showLoader(msg = 'Please wait...') {
    if (this.loadingRef) {
      this.loadingRef?.dismiss()
    }
    this.loadingRef = await this.loadingController.create({
      duration: 6000,
      cssClass: 'please-wait',
      message: msg,
      translucent: true,
      backdropDismiss: true
    });
    await this.loadingRef.present();
  }

  // Save As draft alert to confirm
  async errorAlert(msg) {
    const alert = await this.alertController.create({
      animated: true,
      cssClass: 'error-alert',
      header: '',
      message: `
      <p class="warning-text-header"><ion-icon name="information-circle-outline" color="warning"></ion-icon></p>
      ${msg}
      `,
      buttons: [
        {
          text: 'ok', role: 'Ok', cssClass: 'ok', handler: () => {
            alert.dismiss();
          }
        }]
    });

    await alert.present();
  }


  // Save As draft alert to confirm
  async saveAsDraftAlert() {
    const alert = await this.alertController.create({
      animated: true,
      cssClass: 'saveAsDraftAlert',
      header: 'SAVE AS DRAFT ?',
      message: 'Are you sure you want to save the draft?',
      buttons: [
        { text: 'Discard', role: 'cancel', cssClass: 'cancel' },
        {
          text: 'Save Draft', role: 'Ok', cssClass: 'ok', handler: () => {
            this.saveAsDraft();
          }
        }]
    });

    await alert.present();
  }


  // Save As draft alert to show success
  async saveAsDraftSuccessAlert() {
    const alert = await this.alertController.create({
      animated: true,
      cssClass: 'saveAsDraftAlert Succuss',
      header: '',
      message: 'Your form submission has been saved as a draft. we have sent you an email with a link to complete your submission.',
      buttons: [{ text: 'OK', role: 'cancel', cssClass: 'ok' }]
    });

    await alert.present();
  }

  // Form validation alert
  async formValidationAlert() {
    const alert = await this.alertController.create({
      cssClass: 'saveAsDraftAlert',
      header: 'Alert',
      message: 'Please fill all mandatory details',
      buttons: [{ text: 'OK', role: 'cancel', cssClass: 'ok' }]
    });
  }


  async formSubmitSuccess(msg = 'Work details form submitted successfully') {
    const alert = await this.alertController.create({
      animated: true,
      cssClass: 'saveAsDraftAlert Succuss2',
      header: '',
      message: msg,
      buttons: [{ text: 'OK', role: 'cancel', cssClass: 'ok' }]
    });

    await alert.present();
  }


  async formFailToSubmit() {
    const alert = await this.alertController.create({
      animated: true,
      cssClass: 'error-alert',
      header: '',
      message: 'Oops, Something went wrong, Please fill the form again.',
      buttons: [{ text: 'OK', role: 'cancel', cssClass: 'ok' }]
    });

    await alert.present();
  }

}
